// Control de actualización de saldo durante animaciones de juegos.
// Permite diferir las actualizaciones de saldo por socket mientras hay una animación en curso,
// evitando que el usuario vea el saldo final antes de que termine la animación.

let _deferring = false;
let _pendingRefresh = null;

/**
 * Activa el diferimiento de actualizaciones de saldo.
 * Llamar al inicio de una jugada (cuando el usuario hace clic en "Jugar").
 */
export const startDeferring = () => {
  _deferring = true;
  _pendingRefresh = null;
};

/**
 * Desactiva el diferimiento y ejecuta la actualización pendiente si existe.
 * Llamar cuando la animación del juego termina y se muestra el resultado.
 */
export const stopDeferring = () => {
  _deferring = false;
  if (_pendingRefresh) {
    const callback = _pendingRefresh;
    _pendingRefresh = null;
    callback();
  }
};

/**
 * Indica si las actualizaciones de saldo están siendo diferidas.
 */
export const isDeferring = () => _deferring;

/**
 * Almacena un callback pendiente para ejecutar cuando se dejen de diferir las actualizaciones.
 * Típicamente almacena la función silentRefreshUserData del UserContext.
 */
export const setPendingRefresh = (callback) => {
  _pendingRefresh = callback;
};

// Callback a nivel de módulo para actualizar el saldo directamente desde los juegos
let _onSaldoFinal = null;

/**
 * Registra el callback que actualiza el saldo en el SessionBar.
 * Lo llama el componente React al montar.
 */
export const registrarOnSaldoFinal = (callback) => {
  _onSaldoFinal = callback;
};

/**
 * Dispara la actualización directa del saldo. Lo llaman los juegos Phaser.
 */
export const dispararSaldoFinal = (saldo) => {
  if (_onSaldoFinal) _onSaldoFinal(saldo);
};
